export const StandardizedTestingData = [
  {
    title: 'Gamified Learning That Keeps You Engaged',
    description:
      'Earn points, unlock badges, and compete with friends on the leaderboard. Stay motivated as you progress through lessons, complete challenges, and improve your scores in a fun, interactive way!',
    img: '/images/standardized-testing/gamified.png',
    isImageLeft: true,
  },
  {
    title: 'AI-Powered Study Plans',
    description:
      'Set your test score goals, and let AI create a custom study plan with targeted strategies to help you achieve them efficiently.',
    img: '/images/standardized-testing/study-plans.png',
    isImageLeft: false,
  },
  {
    title: 'Realistic Practice Tests',
    description:
      'Take full-length practice tests with AI-generated feedback that pinpoints mistakes and provides actionable insights for improvement.',
    img: '/images/standardized-testing/practice-test.png',
    isImageLeft: true,
  },
  {
    title: 'Comprehensive Learning Modules',
    description:
      'Deep dive into every subject with structured lessons, interactive exercises, and AI-driven recommendations to strengthen weak areas.',
    img: '/images/standardized-testing/learning-module.png',
    isImageLeft: false,
  },
  {
    title: 'Smart Progress Tracking',
    description:
      'Review past test results, track your improvement with detailed graphs, and discover strengths and weaknesses in each subject.',
    img: '/images/standardized-testing/progress-tracking.png',
    isImageLeft: true,
  },
  {
    title: 'Expert Tutor Support',
    description:
      'Struggling with a concept? Hire ACT/SAT tutors for personalized guidance and accelerate your learning.',
    img: '/images/standardized-testing/tutor-support.png',
    isImageLeft: false,
  },
];
